import { CreateInviteUserIdentityForm } from './steps-form/create-invite-user-identity-form.tsx';
import { CreateInviteUserPlantsForm } from './steps-form/create-invite-user-plants-form.tsx';
import { CreateInviteUserWelcomeForm } from './steps-form/create-invite-user-welcome-form.tsx';
import {
  inviteUserIdentityFormSchema,
  inviteUserPlantsFormSchema,
  inviteUserWelcomeFormSchema,
} from '@/features/users/schemas/invite-user.schema.ts';

export const CREATE_INVITE_USER_STEPS = [
  {
    step: 1,
    titleKey: 'users.invite.steps.identity.title',
    Element: CreateInviteUserIdentityForm,
    schema: inviteUserIdentityFormSchema,
  },
  {
    step: 2,
    titleKey: 'users.invite.steps.plants.title',
    Element: CreateInviteUserPlantsForm,
    schema: inviteUserPlantsFormSchema,
  },
  {
    step: 3,
    titleKey: 'users.invite.steps.welcome.title',
    Element: CreateInviteUserWelcomeForm,
    schema: inviteUserWelcomeFormSchema,
  },
] as const;
